/**
 * Re-syncs card-gallery slideshows when the grid view (vista-1/2/3) changes,
 * or when a Product Recommendations block's "Use R media" setting changes,
 * since both rely on CSS visibility rules that the slideshow-component's
 * internal scroll/index state doesn't know about on its own.
 */
const GRID_SELECTOR = '.product-grid[product-grid-view]';
const RECOMMENDATIONS_SELECTOR = 'product-recommendations';

function resyncCardSlideshows(root = document) {
  const slideshows = root.querySelectorAll('.card-gallery slideshow-component');
  for (const slideshow of slideshows) {
    if (typeof slideshow.select === 'function') {
      slideshow.select(0, undefined, { animate: false });
    }
  }
}

function observeGridViewChanges() {
  const grid = document.querySelector(GRID_SELECTOR);
  if (!grid) return;

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.attributeName === 'product-grid-view') {
        requestAnimationFrame(() => resyncCardSlideshows(grid));
      }
    }
  });

  observer.observe(grid, { attributes: true, attributeFilter: ['product-grid-view'] });
}

function observeUseRMediaChanges() {
  document.querySelectorAll(RECOMMENDATIONS_SELECTOR).forEach((block) => {
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.attributeName === 'data-use-r-media') {
          requestAnimationFrame(() => resyncCardSlideshows(block));
        }
      }
    });
    observer.observe(block, { attributes: true, attributeFilter: ['data-use-r-media'] });
  });
}

function observeAllViewChanges() {
  observeGridViewChanges();
  observeUseRMediaChanges();
}

document.addEventListener('DOMContentLoaded', observeAllViewChanges);
if (document.readyState !== 'loading') observeAllViewChanges();